var cibSpectrum = ["32 32", "<path d='M0 13.599c0 1.328 1.073 2.401 2.401 2.401h2.401c6.181 0 11.197 5.016 11.197 11.197v2.401c0 1.328 1.073 2.401 2.401 2.401h11.197c1.328 0 2.401-1.073 2.401-2.401v-2.401c0-15.020-12.177-27.197-27.197-27.197h-2.401c-1.328 0-2.401 1.073-2.401 2.401z'/>"];

export { cibSpectrum };

